import { createLinkMatcherWithRegExp } from '@lexical/link'

export const URL_MATCHER = createLinkMatcherWithRegExp(/https?:\/\/((?!\s).)+/i)
